import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import SearchBox from "./SearchBox";
import GroupageShipmentRow from "./GroupageShipmentRow";
import { useDispatch, useSelector } from "react-redux";
import { getShipments, reset } from "../features/shipments/shipmentSlice";
import {
  bulkAddShipmentToGroupage,
  getGroupage,
} from "../features/groupages/groupageSlices";

const GroupageSearchDialog = ({ groupage, open, handleClose }) => {
  const listLimit = 100;
  const [selectedShipmentIds, setSelectedShipmentIds] = useState([]);
  const dispatch = useDispatch();
  const { shipments, isLoading, isError, message } = useSelector(
    (state) => state.shipments,
  );

  const filteredShipments =
    !!shipments && !!groupage
      ? shipments.filter(
          (shipment) =>
            !groupage?.Shipments?.find((gs) => gs.id === shipment.id),
        )
      : [];

  const handleShipmentSelected = (shipment) => {
    if (!selectedShipmentIds.includes(shipment.id)) {
      setSelectedShipmentIds((prevState) => [...prevState, shipment.id]);
    } else {
      setSelectedShipmentIds((prevState) =>
        prevState.filter((id) => id !== shipment.id),
      );
    }
  };

  const handleSearchQueryChanged = (newQuery) => {
    let params = {};
    params = { activeFolder: "/", q: newQuery };
    dispatch(getShipments(params));
  };

  const handleAllShipmentChecked = () => {
    if (
      selectedShipmentIds.length ===
      filteredShipments?.filter((s) => !s.isClosed).length
    ) {
      setSelectedShipmentIds([]);
    } else {
      setSelectedShipmentIds(
        filteredShipments.filter((s) => !s.isClosed).map((s) => s.id),
      );
    }
  };

  const handleBulkAddShipments = async () => {
    await dispatch(
      bulkAddShipmentToGroupage({
        groupage_id: groupage.id,
        data: selectedShipmentIds.map((shipmentId) => ({
          GroupageId: groupage.id,
          ShipmentId: shipmentId,
        })),
      }),
    );
    dispatch(getGroupage(groupage.id));
    handleClose();
  };

  useEffect(() => {
    if (open) {
      dispatch(reset());
    } else {
      setSelectedShipmentIds([]);
    }
  }, [open, dispatch]);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <Typography mb={3}>Add Shipments</Typography>
        <SearchBox
          label="Tracking No."
          placeholder="CN / SBBK / MAWB / SMU"
          onQueryChanged={handleSearchQueryChanged}
          hideLogo
        />
        {isLoading && <LinearProgress />}
        <Stack gap={0}>
          {filteredShipments && filteredShipments.length > 0 && (
            <Stack direction={"row"} mb={1} gap={1}>
              <Checkbox
                sx={{ p: 0 }}
                checked={
                  filteredShipments?.filter((s) => !s.isClosed).length ===
                  selectedShipmentIds.length
                }
                indeterminate={
                  selectedShipmentIds.length > 0 &&
                  selectedShipmentIds.length !==
                    filteredShipments?.filter((s) => !s.isClosed).length
                }
                onChange={handleAllShipmentChecked}
              />
              <Typography>{filteredShipments.length} Shipments</Typography>
            </Stack>
          )}
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ maxHeight: "300px" }}>
        <Stack gap={0}>
          {filteredShipments &&
            filteredShipments
              .slice(0, listLimit)
              .map((shipment) => (
                <GroupageShipmentRow
                  key={shipment.id}
                  shipment={shipment}
                  isChecked={selectedShipmentIds.includes(shipment.id)}
                  handleChecked={handleShipmentSelected}
                />
              ))}
        </Stack>
        {filteredShipments &&
          filteredShipments.length > listLimit &&
          `${filteredShipments.length - listLimit} more`}
        {isError && message}
      </DialogContent>
      <DialogActions>
        <Button color="inherit" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          disabled={selectedShipmentIds?.length === 0}
          onClick={handleBulkAddShipments}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GroupageSearchDialog;
